export default __webpack_public_path__ + "static/media/p9.be4f80b7.jpg";